import script from "./UDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UDialog.vue?vue&type=style&index=0&id=8f724298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f724298"]])

export default __exports__